import { LIST_BACKUPS_FOR_FLOW, LIST_BACKUPS_FOR_CRED, GET_BACKUP, GET_ALL_FLOWS_WITH_BACKUPS, GET_BACKUP_TOKEN } from "../actions/types";
const initialState = {
  flowBackups: [],
  credBackups: [],
  backup: undefined,
  allFlowsWithBackup: [],
  backupToken: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LIST_BACKUPS_FOR_FLOW:
      return {
        ...state,
        flowBackups: action.payload,
      };
    case LIST_BACKUPS_FOR_CRED:
      return {
        ...state,
        credBackups: action.payload,
      };
    case GET_BACKUP:
      return {
        ...state,
        backup: action.payload,
      };
    case GET_ALL_FLOWS_WITH_BACKUPS:
      return {
        ...state,
        allFlowsWithBackup: action.payload,
      };
    case GET_BACKUP_TOKEN:
      return {
        ...state,
        backupToken: action.payload,
      };
    default:
      return state;
  }
}
